import React from 'react';
import VideoHero from '../components/VideoHero';
import { whyChooseUs, packages } from '../mock/data';
import PackageCard from '../components/PackageCard';
import ContactButtons from '../components/ContactButtons';
import { Sparkles, Users, Award, MapPin } from 'lucide-react';

const iconMap = {
  Sparkles: Sparkles,
  Users: Users,
  Award: Award,
  MapPin: MapPin
};

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <VideoHero />

      {/* Why Choose Us Section */}
      <section className="py-20 bg-[var(--dark-bg)]">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16 fade-in">
            <h2 className="text-3xl md:text-5xl font-bold font-['Playfair_Display'] text-[var(--gold)] mb-4">
              Neden Bizi Seçmelisiniz?
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">
              Crocus Hamam Spa olarak, müşterilerimize en yüksek kalitede hizmet sunmayı ve unutulmaz bir deneyim yaşatmayı hedefliyoruz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {whyChooseUs.map((item, index) => {
              const IconComponent = iconMap[item.icon];
              return (
                <div
                  key={item.id}
                  className="glass rounded-xl p-6 card-hover fade-in"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="w-16 h-16 rounded-full bg-[var(--gold)]/10 flex items-center justify-center">
                      <IconComponent size={32} className="text-[var(--gold)]" />
                    </div>
                    <h3 className="text-xl font-bold font-['Playfair_Display'] text-[var(--gold)]">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Important Notice */}
          <div className="mt-12 max-w-4xl mx-auto">
            <div className="glass rounded-xl p-6 border-l-4 border-[var(--gold)]">
              <p className="text-gray-300 text-center text-sm md:text-base leading-relaxed">
                <span className="text-[var(--gold)] font-bold">Ailelerimize Önemli Bilgi:</span> Tesisimiz,
                kadın ve erkek müşterilerimize randevu sistemi ile hizmet vermektedir. Profesyonel,
                etik ve ailelere uygun bir ortam sunuyoruz. Tesisimizde yalnızca lisanslı sağlık ve
                terapi hizmetleri sunulmaktadır.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="py-20 bg-[var(--dark-card)]">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16 fade-in">
            <h2 className="text-3xl md:text-5xl font-bold font-['Playfair_Display'] text-[var(--gold)] mb-4">
              Paketlerimiz
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">
              Size en uygun paketi seçin ve unutulmaz bir rahatlama deneyimi yaşayın.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {packages.map((pkg, index) => (
              <PackageCard key={pkg.id} pkg={pkg} index={index} />
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <p className="text-gray-400 text-sm">
              Tüm paketlerimiz önceden randevu alınarak uygulanır. Detaylı bilgi için iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[var(--dark-bg)]">
        <div className="container mx-auto px-4">
          <div className="glass rounded-2xl p-8 md:p-12 text-center space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold font-['Playfair_Display'] gold-gradient-text">
              Randevu Almak İster misiniz?
            </h2>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto">
              Size özel bir deneyim sunmak için hazırız. Hemen randevu alın ve kendinize bir mola verin.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              <ContactButtons />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;